export default __webpack_public_path__ + "static/media/Amulet of Zarallo.d9901709.jpg";